// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "kolibri.core.default_frontend-" + (chunkId === 490 ? "intl" : chunkId) + "-0.17.5.js";
};